<div class="invoice-page">
  <div class="invoice-container">
    @if (!carregando) {
    <div class="status-line">
      <div class="status-content">
        <span class="status-dot"></span>
        <span>{{ statusDescricao }}</span>
      </div>

      <a class="report-link" href="javascript:void(0)">Reportar problema</a>
    </div>

    <section class="card">
      <h2>Dados da fatura - {{ fatura?.numeroFatura }}</h2>

      <div class="summary-grid">
        <div class="summary-box">
          <div class="summary-label">Valor total</div>
          <div class="summary-value">
            {{
              fatura?.valorTotal
                | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
            }}
          </div>
        </div>

        <div class="summary-box">
          <div class="summary-label">Data de vencimento</div>
          <div class="summary-value">
            {{ fatura?.dataVencimento | date : 'dd/MM/yyyy' }}
          </div>
          <div class="summary-subtext">{{ diasParaVencimento }}</div>
        </div>
      </div>

      @if (fatura?.descricao) {
      <div class="description-box">
        <div class="summary-label">Descrição</div>
        <p>{{ fatura?.descricao }}</p>
      </div>
      }
    </section>

    @if (fatura?.compradorNome) {
    <section class="card">
      <h2>Dados do comprador</h2>

      <div class="buyer-grid">
        @if (fatura?.compradorNome) {
        <div>
          <div class="field-label">Nome</div>
          <div class="field-value">{{ fatura?.compradorNome }}</div>
        </div>
        } @if (fatura?.compradorEmail) {
        <div>
          <div class="field-label">Email</div>
          <div class="field-value">{{ fatura?.compradorEmail }}</div>
        </div>
        }
      </div>
    </section>
    }

    <section class="card">
      <h2>Selecione a forma de pagamento</h2>

      <div class="payment-tabs">
        <button
          type="button"
          class="payment-tab"
          [class.active]="formaPagamentoSelecionada === 'boleto'"
          (click)="selecionarFormaPagamento('boleto')"
        >
          Boleto Bancário
        </button>

        <button
          type="button"
          class="payment-tab"
          [class.active]="formaPagamentoSelecionada === 'pix'"
          (click)="selecionarFormaPagamento('pix')"
        >
          Pix
        </button>
      </div>

      @if (formaPagamentoSelecionada === 'boleto') {
      <div class="payment-content">
        <h3>Boleto bancário para pagamento</h3>

        <div class="payment-layout">
          <div class="payment-left boleto-left">
            <div class="boleto-preview" (click)="abrirBoleto()">
              <img
                title="Visualizar boleto"
                src="assets/images/boleto.png"
                alt="Pré-visualização do boleto"
                class="boleto-preview-image"
              />
            </div>

            <div class="actions">
              <button type="button" class="btn-primary" (click)="abrirBoleto()">
                Visualizar
              </button>
              <button
                type="button"
                class="btn-primary"
                (click)="imprimirBoleto()"
              >
                Imprimir
              </button>
            </div>
          </div>

          <div class="payment-right">
            <div class="secure-box">
              <div class="secure-icon">SSL</div>
              <div>
                <div class="secure-title">SITE SEGURO</div>
                <div class="secure-subtitle">
                  Protegido por validação segura
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      } @if (formaPagamentoSelecionada === 'pix') {
      <div class="payment-content">
        <h3>Pix</h3>

        <div class="payment-layout">
          <div class="payment-left pix-left">
            <div class="pix-info-row">
              @if (fatura?.pixCopiaECola) {
              <div class="qr-box">
                <qrcode
                  class="pix-qrcode"
                  [qrdata]="fatura?.pixCopiaECola!"
                  [width]="220"
                  [errorCorrectionLevel]="'M'"
                  [margin]="1"
                  [scale]="1"
                  [alt]="'QR Code Pix'"
                  [colorDark]="'#000000ff'"
                  [colorLight]="'#ffffffff'"
                  [elementType]="'canvas'"
                  [ariaLabel]="'QR Code Pix para pagamento'"
                ></qrcode>
              </div>

              <div class="pix-side">
                <div class="pix-text">
                  Use o aplicativo do seu banco para escanear o QR Code e pagar
                  de forma rápida e segura. Após o pagamento enviar o
                  comprovante para nosso Zap +55 79 9937-1307
                </div>

                <button
                  type="button"
                  class="btn-primary btn-fit"
                  (click)="copiarPix()"
                >
                  Copiar código Pix
                </button>
              </div>
              } @else {
              <div class="qr-box">
                <div class="pix-placeholder">
                  CNPJ<br />
                  {{ fatura?.empresaCnpjPix }}
                </div>
              </div>

              <div class="pix-side">
                <div class="pix-text">
                  Use a chave Pix da empresa para pagamento rápido e seguro.
                </div>
              </div>
              }
            </div>

            <div class="pix-copy-section">
              <div class="field-label">Código Pix copia e cola</div>
              <div class="pix-code">
                {{ fatura?.pixCopiaECola || fatura?.empresaCnpjPix }}
              </div>

              <div class="field-label top-space">Chave Pix (CNPJ)</div>
              <div class="pix-code">
                {{ fatura?.empresaCnpjPix }}
              </div>

              <div class="actions">
                <button type="button" class="btn-primary" (click)="copiarPix()">
                  Copiar
                </button>
              </div>
            </div>
          </div>

          <div class="payment-right">
            <div class="secure-box">
              <div class="secure-icon">SSL</div>
              <div>
                <div class="secure-title">SITE SEGURO</div>
                <div class="secure-subtitle">
                  Protegido por validação segura
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </section>
    } @else {
    <div class="card">
      <p>Carregando fatura...</p>
    </div>
    }
  </div>
</div>
<p-toast></p-toast>
